import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';
import { GasInputModule } from '../../forms/gas-input/gas-input.module';
import { GasFiltersModule } from '../gas-filters/gas-filters.module';
import { GasFormKeyModule } from '../../utils/gas-form-key/gas-form-key.module';
import { GasTableHeaderComponent } from './gas-table-header.component';
import { GasSpinnerModule } from '../gas-spinner/gas-spinner.module';

const COMPONENTS = [
  GasTableHeaderComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    GasIconsModule,
    GasInputModule,
    GasFiltersModule,
    GasFormKeyModule,
    GasSpinnerModule,
  ],
})
export class GasTableHeaderModule { }
